import getFetchOptions from 'utils/getFetchOptions';
import {ENDPOINT_URL} from 'constants/index';

const COUNTRY = process.env.REACT_APP_COUNTRY || 'sweden';

export default async function getLanguageConfig(app = 'backoffice') {
	try {
		const response = await fetch(
			`${ENDPOINT_URL}/language-config?country=${COUNTRY}&app=${app}`,
			getFetchOptions({method: 'GET'})
		);
		if (!response.ok) return {};
		return await response.json();
	} catch {
		return {};
	}
}
